/**
 * @generated SignedSource<<98eb757b0140bc87d1230f7035f65b44>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Country = "CH" | "DE";
import { FragmentRefs } from "relay-runtime";
export type waitingRoomPreview_waitingRoomAppointment$data = {
  readonly appointment: {
    readonly patient: {
      readonly country: Country;
      readonly id: string;
    };
  };
  readonly " $fragmentType": "waitingRoomPreview_waitingRoomAppointment";
};
export type waitingRoomPreview_waitingRoomAppointment$key = {
  readonly " $data"?: waitingRoomPreview_waitingRoomAppointment$data;
  readonly " $fragmentSpreads": FragmentRefs<"waitingRoomPreview_waitingRoomAppointment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "waitingRoomPreview_waitingRoomAppointment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Appointment",
      "kind": "LinkedField",
      "name": "appointment",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "patient",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "country",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WaitingRoomAppointment",
  "abstractKey": null
};

(node as any).hash = "12e6c8e651a4c532e88830d2c2c88d4c";

export default node;
